import { BUSINESSES_FAILURE, BUSINESSES_REQUEST, BUSINESSES_SUCCESS } from '../actions/businesses'

export function businesses(
  state = {
    isFetching: false,
    results: [],
    errorMessage: null,
    count: 0,
    nextUrl: null,
    requestUrl: null,
  },
  action
) {
  switch (action.type) {
    case BUSINESSES_REQUEST:
      return { ...state, isFetching: true, errorMessage: null }
    case BUSINESSES_SUCCESS:
      return {
        ...state,
        isFetching: false,
        results: action.response.results,
        count: action.response.count,
        nextUrl: action.response.next,
        errorMessage: null,
        requestUrl: action.requestUrl,
      }
    case BUSINESSES_FAILURE:
      return { ...state, isFetching: false, errorMessage: action.error, requestUrl: action.requestUrl }
    default:
      return state
  }
}
